module.exports = __webpack_public_path__ + "img/card_result@2x.2687c449.png";